import axios from 'axios';
import { env } from 'process';

// Cố định baseURL để tránh lỗi
const API_URL = 'https://api.hoaithuongfruits.com/api';
// const API_URL = 'http://192.168.1.79:8080/api';
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor để thêm token vào header Authorization
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Kiểm tra token có hết hạn không trước khi gửi request
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Date.now() / 1000;
        if (payload.exp && payload.exp < currentTime) {
          console.log('Token đã hết hạn, đang logout...');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/auth/login';
          return Promise.reject(new Error('Token expired'));
        }
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Lỗi khi kiểm tra token:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/auth/login';
        return Promise.reject(error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor để xử lý lỗi authentication (401)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Chỉ logout nếu thực sự là lỗi token hết hạn hoặc không hợp lệ
      // Không logout khi có lỗi mạng hoặc server
      if (error.response.data && error.response.data.message) {
        const message = error.response.data.message.toLowerCase();
        if (message.includes('token') && (message.includes('hết hạn') || message.includes('không hợp lệ') || message.includes('expired') || message.includes('invalid'))) {
          console.log('Token hết hạn hoặc không hợp lệ, đang logout...');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/auth/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api; 